module.exports = __webpack_public_path__ + "static/media/emtpyMovie.a5d49a56.jpg";